import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale } from "chart.js";
import { FaUserCircle } from "react-icons/fa";
import { Card, CardContent } from "../components/ui/card";
import BalanceCard from "./BalanceCard";
import Menu from './menu';
import axios from '../axiosInstance';
import jwtDecode from "jwt-decode"; // Pour décoder le token JWT
import rollercoinBanner from "../assets/images/bannerRollerCoin.gif"; // Image de bannière RollerCoin
import logoBanner from "../assets/images/new_logo_without_font.png";
import { FaTelegramPlane, FaFacebookF, FaXTwitter } from "react-icons/fa6";
import HighPerformanceAd from "../components/HighPerformanceAd";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import KpiCards from "../components/KpiCards";
import { Footer } from "../components/ Footer";

// Initialisation des composants ChartJS pour afficher des graphiques
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

function Toast({ message, type = "error", onClose }) {
  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
      <div className="flex items-center space-x-2">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
      </div>
    </div>
  );
}



// Composant principal de la page Marketplace
export default function Parameters({ onLogout }) {
  const [options, setOptions] = useState(0); // Options disponibles dans le marketplace
  const [coinz, setCoinz] = useState(0); // Solde en COINZ
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0) // Son propre bénéfice
  const [balance, setBalance] = useState(300); // Solde de l'utilisateur
  const [weeklyProfit, setWeeklyProfit] = useState(0); // Bénéfice hebdomadaire
  const [toast, setToast] = useState({ message: "", type: "" });
  const [message, setMessage] = useState("");
  const [userLevel, setUserLevel] = useState(1);
  const [userXP, setUserXP] = useState(0);
  const [xpForNextLevel, setXpForNextLevel] = useState(100);
  const showToast = (message, type = "error") => {
	console.log("test");
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
	
 // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API
  const getUserData = () => {
    

    axios.get(`/api/user/me`,{ withCredentials: true })
      .then((response) => {
        const { coinz, options, systemCoinz, weeklyProfit, lastclaim, userLevel, user_Xp, xpForNextLevel  } = response.data;
		const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		
		setSelfWeeklyProfit(valeurCalculee);
        setCoinz(coinz);
        setOptions(options);
        setWeeklyProfit(weeklyProfit);  
		setUserLevel(userLevel);
		setUserXP(user_Xp);
		setXpForNextLevel(xpForNextLevel);
       
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      
      });
  };

  
  // Appeler la fonction au chargement du composant
  useEffect(() => {
	document.title = "Level up | CoinzUp";
	getUserData();
  }, []);
  return (
	<>
	  {toast.message && (
		<Toast
		  message={toast.message}
		  type={toast.type}
		  onClose={() => setToast({ message: "", type: "" })}
		/>
	  )}
  
	  <div className="min-h-screen flex flex-col bg-gray-900 text-white font-sans">
		{/* Contenu principal avec sidebar */}
		<div className="flex flex-1 min-h-[calc(100vh-64px)]">
		  {/* Sidebar */}
		  <Sidebar onLogout={onLogout}/>
  
		  {/* Contenu principal */}
		  <main className="flex-1 px-4 sm:px-10 py-8 overflow-auto min-w-0 space-y-10">
		  <Header title="Level Up"  balance={coinz}        optionsOwned={options}        estimatedWeeklyGain={selfWeeklyProfit} />
  
	  	{/* Ad haut */}
			<HighPerformanceAd
            keyId="fd5da3543c594f07b73630f461f10613"
            width={728}
            height={90}
          />  

			{/* User Level Card */}
			<div className="max-w-5xl mx-auto bg-gray-800 rounded-lg border border-gray-700 shadow-sm p-6">
			  <h2 className="text-lg font-semibold mb-4 text-white">User Level</h2>
			  <div className="flex items-center justify-between mb-2 text-sm text-gray-300">
				<span>Level {userLevel}</span>
				<span>
				  {userXP} / {xpForNextLevel} XP
				</span>
			  </div>
			  <div className="w-full bg-gray-700 rounded-full h-2 mb-4">
				<div
				  className="bg-blue-500 h-2 rounded-full transition-all"
				  style={{ width: `${(userXP / xpForNextLevel) * 100}%` }}
				/>
			  </div>
			</div>
  
			{/* Leveling System Explanation */}
			<section className="max-w-5xl mx-auto bg-gray-800/60 border border-gray-700 rounded-xl shadow p-6 space-y-4">
			  <h2 className="text-2xl font-bold text-yellow-400">🎯 Leveling System</h2>
			  <p className="text-sm text-gray-300">
				Earn experience (<span className="text-green-400 font-semibold">XP</span>) by trying the{" "}
				<strong>hourly draws (+25xp)</strong>, by{" "}
				<strong>purchasing ads (+2000xp), by using autosurf (+60xp each hours) and for each completed order in the marketplace (+50xp)</strong>.
			  </p>
			  <p className="text-sm text-gray-300">
				Reaching higher levels unlocks exclusive bonuses:
			  </p>
			  <ul className="list-disc pl-5 text-sm text-gray-200 space-y-2">
				<li>
				  <ul className="list-disc pl-5 space-y-1">
					<li>Level 1: x1</li>
					<li>Level 2: x1.2</li>
					<li>Level 5: x1.3</li>
					<li>Level 5: x1.4</li>
					<li>Level 5: x1.5</li>
					<li>Level 6: x1.6</li>
					<li>Level 7: x1.7</li>
					<li>Level 8: x2</li>
					<li>Level 9: x2.5</li>
					<li>Level 10: x3</li>
				  </ul>
				</li>
				<li>
				  ⚠️ If you stay inactive (no draws or autosurf), you’ll <strong>lose 5% of your total XP</strong>. Stay active to keep progressing!
				</li>
			  </ul>
  
			  {/* Level Table */}
			  <div className="overflow-x-auto">
				<table className="min-w-full text-sm text-left text-gray-300 border border-gray-700 rounded overflow-hidden">
				  <thead className="bg-gray-800 text-gray-200">
					<tr>
					  <th className="px-4 py-2 border-r border-gray-700">Level</th>
					  <th className="px-4 py-2">Required XP</th>
					</tr>
				  </thead>
				  <tbody>
					{[
					  { level: 1, xp: 0 },
					  { level: 2, xp: 2000 },
					  { level: 3, xp: 4000 },
					  { level: 4, xp: 8000 },
					  { level: 5, xp: 16000 },
					  { level: 6, xp: 32000 },
					  { level: 7, xp: 64000 },
					  { level: 8, xp: 128000 },
					  { level: 9, xp: 256000 },
					  { level: 10, xp: 512000 },
					].map(({ level, xp }) => (
					  <tr key={level} className="border-t border-gray-700">
						<td className="px-4 py-2 font-medium text-yellow-300">{level}</td>
						<td className="px-4 py-2">{xp.toLocaleString()} XP</td>
					  </tr>
					))}
				  </tbody>
				</table>
			  </div>
			</section>
  
			{/* Bottom ad */}
			<div className="max-w-5xl mx-auto">
			  <HighPerformanceAd
				keyId="96e99453a24be0353f2fe26dc0b9b728"
				width={468}
				height={60}
			  />
			</div>
		  </main>
		</div>
  
		{/* Footer */}
		<Footer />
	  </div>
	</>
  );
  
}
